<template>
  <div class="login">
    <div class="loginContent">
      <div class="loginTop" :style="{'--loginBg': `url(${bgImage})` }" :class="`${isZN ? 'isZN': ''}`">
        <h2 v-if="nameFlag">远程健康咨询管理系统</h2>
        <h2 v-else-if="isSctcm">四川中医重症联盟网络平台</h2>
        <h2 v-else-if="isYntcm">云南急危重学科联盟支持系统</h2>
        <h2 v-else-if="isGuangAn">广安市人民医院神经内科学科联盟</h2>
        <h2 v-else-if="isZN">远程健康咨询管理系统</h2>
        <h2 v-else>四川大学华西医院重症医学科学科联盟</h2>
        <div class="cloud1">
          <img src="../../assets/cloud1.png" alt="">
        </div>
        <div class="cloud2">
          <img src="../../assets/cloud2.png" alt="" width="54" height="32">
        </div>
        <div class="cloud3">
          <img src="../../assets/cloud3.png" alt="" width="23" height="16">
        </div>
      </div>
      <div class="loginForm">
        <el-input v-model="ruleForm.loginName" type="text" placeholder="账号" @keyup.enter.native="keyLogin($event)"></el-input>
        <el-input v-model="ruleForm.passwords" type="password" placeholder="密码" @keyup.enter.native="keyLogin($event)"></el-input>
        <button @click="login">登录</button>
      </div>
    </div>
    <div class="loginContent-bg"></div>
    <div class="loginBottom">
      <a v-if="nameFlag || isZN" target="_blank" href="https://beian.miit.gov.cn" rel="nofollow">技术支持：成都嘉逸科技有限公司 蜀ICP备13020940号</a>
      <a v-else target="_blank" href="https://beian.miit.gov.cn" style="color:#1890ff !important;" rel="nofollow">技术支持：四川智康科技有限责任公司  蜀ICP备13020940号</a>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import host from '../../mixins/host.js'
export default {
  mixins: [host],
  data(){
    return{
      ruleForm:{
        loginName:'',
        passwords:''
      },
      hximg: require('../../assets/login-bghx.jpg'),
      jiayiimg: require('../../assets/background.jpg'),
      sctcm: require('../../assets/sctcm_login_bg.jpg'),
      isYntcmImg: require('../../assets/login-bg-ynzy.jpg'),
      isGuangAnImg: require('../../assets/login-bg-ga.jpg'),
      isZNImg: require('../../assets/login-bg-zn.jpg'),
    }
  },
  computed: {
    bgImage() {
      if (this.isSctcm) {
        return this.sctcm
      }
      if (this.nameFlag) {
        return this.jiayiimg
      }
      if (this.isYntcm) {
        return this.isYntcmImg
      }
      if (this.isGuangAn) {
        return this.isGuangAnImg
      }
      if (this.isZN) {
        return this.isZNImg
      }
      return this.hximg
    }
  },
  methods:{
    // enter键登录
    keyLogin(e) {
      this.login()
    },
    login() {
      if (this.ruleForm.loginName == '') {
        this.$message({
          showClose: true,
          message: '请输入账号',
          type: 'error'
        });
        return
      }
      if (this.ruleForm.passwords == '') {
        this.$message({
          showClose: true,
          message: '请输入密码',
          type: 'error'
        });
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '登录中,请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(6, 6, 6, 0.3)'
      })
      this.Axios.get('/api/User/UserLogin/'+this.ruleForm.loginName+','+this.ruleForm.passwords, {timeout: 5000}).then(res=>{ //登录
        if(res.data.result.status === 100){
          localStorage.setItem('defaultActive', '/index')
          loading.close()
          let backInfo = res.data
          // console.log('backInfo', backInfo)
          window.localStorage.setItem('LoginName',backInfo.UserInfo.loginName)
          window.localStorage.setItem("UserId",res.data.result.userID)
          window.localStorage.setItem("isFirst",backInfo.result.firstLogin)
          window.localStorage.setItem('HospitalName',backInfo.result.hospitalName)
          window.localStorage.setItem('HospitalID',backInfo.result.hospitalId)
          localStorage.setItem('userName', backInfo.result.userName)
          if(backInfo.result.firstLogin){       //判断是否为第一次登录
            this.$router.push({path:'updatePsd'})
          }else{
            this.$router.push({path:'index'})
            // var sUserAgent = navigator.userAgent.toLowerCase()
            // console.log('sUserAgent', sUserAgent)
          }
        }else{
          loading.close()
          this.$message({
            showClose: true,
            message: res.data.result.message,
            type: 'error'
          });
          // this.$refs.mybox.style.left='8px'
        }

      }).catch(error=>{
        // console.log(error)
        loading.close()
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员!',
          type: 'error'
        });
      })
      return false
    }
  }
}
</script>

<style lang="less">
.login {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items:center;
  flex-direction: column;
  background-color: rgb(220, 238, 255);
  background-size: cover;
  .loginBottom{
    width: 500px;
    display: flex;
    /*flex-wrap: wrap;*/
    justify-content: center;
    margin-top: 20px;
    align-items: center;
    position: relative;
    z-index: 9;
  }
  .loginContent {
    align-items: center;
    margin-top: 6%;
    border-radius: 4px;
    width: 500px;
    height: 555px;
    background: white;
    position: relative;
    z-index: 999;
    &-bg {
      margin-top: 6%;
      width: 500px;
      height: 555px;
      position: absolute;
      &::before {
        top: -37px;
        position: absolute;
        content: '';
        width: 740px;
        height: 1900px;
        transform: rotate(312deg);
        background-color: #C9DFF3;
        left: 584px;
        z-index: 9;
      }
    }
    .loginTop {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      height: 312px;
      width: 100%;
      border-radius: 4px;
      // background: url('../../assets/login-bghx.jpg');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      // background: url('../../assets/background.jpg') no-repeat; background-size: 100% 100%;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: var(--loginBg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      h2 {
        color: white;
        // width: 288px;
        text-align: center;
        height: 31px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
      .cloud1 {
        width: 100%;
        height: 40px;
        margin-bottom: -70px;
        margin-top: -70px;
        img {
          position: relative;
          top: 0;
          left: 0px;
          animation: cloud1 8s linear infinite;
        }
      }
      .cloud2 {
        width: 100%;
        height: 32px;
        margin-bottom: -50px;
        margin-top: -70px;
        img {
          position: relative;
          top: 0;
          left: 0px;
          animation: cloud2 12s linear infinite;
        }
      }
      .cloud3 {
        width: 100%;
        height: 30px;
        margin-top: -50px;
        img {
          position: relative;
          top: 0;
          left: 0px;
          animation: cloud3 10s linear infinite;
        }
      }

      &.isZN {
        margin-bottom: 35px;
        h2 {
          margin-top: 305px;
          color: rgb(25, 70, 185);
        }
        &::before {
          filter: blur(0.5px);
        }
      }
    }
    .loginForm {
      width: 100%;
      height: 180px;
      margin-top: 20px;
      input {
        width: 80%;
        padding: 0 15px;
        height: 48px;
        line-height: 50px;
        font-size: 13px;
        margin: 0 auto 15px;
        border-radius: 5px;
        display: block;
        background: white;
        box-shadow: 0 0 0px 1000px white inset;
      }
      button {
        width: 80%;
        height: 50px;
        border-radius: 5px;
        color: white;
        background: #1890ff;
        margin: 0 auto 15px;
        border: none;
        display: block;
        cursor: pointer;
        &:hover {
          background: rgba(24, 143, 255, 0.796);
        }
      }
    }

  }
}
@keyframes cloud1 {
  from {left: 680px;}
  to {left: -50px;}
}
@keyframes cloud2 {
  from {left: 600px;}
  to {left: -50px;}
}
@keyframes cloud3 {
  from {left: 640px;}
  to {left: -50px;}
}
</style>



// WEBPACK FOOTER //
// src/page/login/login.vue